// extracted by mini-css-extract-plugin
export default {"depositImage":"depositImage_k19Ol","depositText":"depositText_O8ihj"};